import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material"
import { initReport, serializeQuery } from "helpers/service_helper"
import { CityFromSection } from "hooks/returnCityName"
import { isNumber } from "lodash"
import React, { useState, useEffect, useReducer } from "react"

import { connect } from "react-redux"
import { getGasProjectReport } from "store/actions"

import StiReport from "../../../../assets/reports/GasProjectReport.mrt"
import StiGCityReport from "../../../../assets/reports/GasProjectEngGCityReport.mrt"

import Localizations from "../../../../locales/fa/fa.xml"
import Locations from "components/Common/Locations"
import { Checkbox, Col, Row } from "antd"
import { loadStimulsoftScripts } from "helpers/stimulsoftLoader"
const ExecutorList = props => {
  const { lstGasProjectReport, translate, loading } = props
  const [errorMessage, setErrorMessage] = useState(null)
  const [pageSize, setPageSize] = useState(1000)
  const [page, setPage] = useState(0)
  const [dateRegister, setDateRegister] = useState("")
  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      projectLevelEnum: 0,
      groupReport: 1,
      filterDate: 0,
    }
  )
  const [filterCity, setFilterCity] = useState(false)

  // Helper to ensure Stimulsoft scripts are loaded before using initReport
  const ensureStimulsoftAndInit = async (reportData, groupReport) => {
    await loadStimulsoftScripts()
    if (groupReport === 0) initReport(StiReport, reportData, Localizations)
    else initReport(StiGCityReport, reportData, Localizations)
  }

  useEffect(() => {
    setTimeout(() => {
      setErrorMessage(null)
    }, 3000)
  }, [errorMessage])
  const handleInput = async evt => {
    const name = evt.target.name
    let newValue = evt.target.value
    if (newValue == "on") newValue = evt.target.checked

    if (evt.target.attributes.type?.value === "text") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
    }
    if (evt.target.attributes.type?.value === "number") newValue = +newValue
    if (evt.target.attributes.type?.value === "radio") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
      if (isNumber(parseInt(newValue))) newValue = +newValue
    }

    setFormInput({ [name]: newValue })
  }
  useEffect(() => {
    // props.onGetListExecutor()
    if (lstGasProjectReport.length > 0) {
      const reportData = lstGasProjectReport.map(c => {
        return {
          ...c,
          exeFullName: c.executor.fullName,
          cityName: CityFromSection(c.idSection),
          address:
            c.address.split(":").length > 0
              ? c.address.split(":")[1]
              : c.address,
        }
      })

      ensureStimulsoftAndInit(reportData, formInput.groupReport)
    }
  }, [lstGasProjectReport])

  const prepareReport = async () => {
    let searchQuery = {
      projectLevelEnum: formInput.projectLevelEnum,
      registerDate:
        dateRegister.persian && formInput.filterDate === 0
          ? dateRegister.persian
          : "",
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      cityId: filterCity ? +dataAddress?.cityId : 0,

      page,
      pageSize,
    }
    const params = serializeQuery(searchQuery)
    await props.onGetGasProjectReport(params)
  }

  return (
    <>
      {props.loading && <CircularProgress disableShrink />}
      <Box>
        <Grid
          container
          justifyContent="center"
          spacing={1}
          alignItems="center"
        ></Grid>
        <Grid item xs={12}>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="radio-consent-label"
              name="projectLevelEnum"
              value={formInput.projectLevelEnum}
              onChange={handleInput}
            >
              <FormControlLabel
                value={0}
                control={<Radio />}
                label="بدون فیلتر"
              />
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="انتظار تایید کارشناس"
              />

              <FormControlLabel
                value={2}
                control={<Radio />}
                label="انتظار تایید نقشه"
              />
              <FormControlLabel
                value={3}
                control={<Radio />}
                label="انتظار تایید نقشه با نقص"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="radio-consent-label"
              name="groupReport"
              value={formInput.groupReport}
              onChange={handleInput}
            >
              {/* <FormControlLabel
                  value={0}
                  control={<Radio />}
                  label="گروه بندی مجری"
                /> */}
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="گروه بندی شهر"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        {/* <Grid item xs={4}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="radio-consent-label"
                name="filterDate"
                value={formInput.filterDate}
                onChange={handleInput}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio />}
                  label="با تاریخ"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio />}
                  label="بدون تاریخ"
                />
              </RadioGroup>
            </FormControl>
          </Grid> */}

        {/* <PersianDatePicker setPersianDate={setDateRegister} disable={false} /> */}
      </Box>
      <Row>
        <Col>
          <Checkbox
            onChange={e => {
              setFilterCity(e.target.checked)
            }}
          >
            فیلترشهر
          </Checkbox>
        </Col>
        {filterCity && (
          <Col 
          className="col-8"
          >
            <Locations
              setDataAddress={setDataAddress}
              matches_sm={true}
              isAccessCity={true}
              inUseFilter={true}
            />
          </Col>
        )}
      </Row>
      <br />
      <Button
        variant="contained"
        onClick={async () => {
          await prepareReport()
        }}
        type="submit"
      >
        گزارش گیری
      </Button>

      {lstGasProjectReport.length > 0 ? (
        <div style={{ maxWidth: "822px" }} id="viewer"></div>
      ) : (
        "رکوردی برای نمایش وجود ندارد مجددا گزارش گیری نمایید"
      )}
    </>
  )
}

const mapStateToProps = ({ GasProjects }) => ({
  lstGasProjectReport: GasProjects.lstGasProjectReport,
  error: GasProjects.error,
  success: GasProjects.success,
  loading: GasProjects.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetGasProjectReport: searchValue =>
    dispatch(getGasProjectReport(searchValue)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ExecutorList)
